import { Component, PLATFORM_ID, Inject, OnInit, OnChanges, Input, ChangeDetectionStrategy, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common'
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';
@Component({
    selector: 'title-row',
    templateUrl: './title-row.template.html',
    styleUrls: ['./title-row.styles.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TitleRow {
    @Input() row$: any;
    
    //private content$: any;
    private isServer: boolean;
    
    /**
     * Item Row Component
     */
    constructor(
        @Inject(PLATFORM_ID) private platformId: string,
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo,
    ) {
        this.isServer = isPlatformServer(this.platformId);
    }


}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/row/title-row/title-row.component.ts